export enum ActionType {
  // creatte user
  UPDATE_STRESS_CHECK = "action/UPDATE_STRESS_CHECK",
  UPDATE_STRESS_CHECK_SUCCESS = "action/UPDATE_STRESS_CHECK_SUCCESS",
  UPDATE_STRESS_CHECK_ERROR = "action/UPDATE_STRESS_CHECK_ERROR",
  RESET_UPDATE_STRESS_CHECK = "action/RESET_UPDATE_STRESS_CHECK",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface UpdateStressCheckData {
  id?: number;
  stress_check_type_id: number;
  name: string;
  start_time: string;
  end_time: string;
  temp_save_to_permant_save?: string;
}
